// import React from 'react'
// // import bg from "../images/bg1.png";

// function BannerImage1() {
//   return (
//     <img src={bg} className="card-img" alt="bg" id="bgImg"  style={{ maxWidth: "50px", maxHeight : "50px" }}/>
    
//   )
// }

// export default BannerImage1

import React from 'react'

const BannerImage1 = ({ bImage }) => {
  return (
    <>
      <img src={bImage} className="card-img " alt="bg" id="bgImg" />
    </>
   
    
  )
};

export default BannerImage1